import { createContext, useContext, useEffect, useState, type ReactNode } from "react";
import type { Crumb } from "@/components/ui/breadcrumb";

type ShellState = { crumbs: Crumb[]; setCrumbs: (c: Crumb[]) => void };

const ShellContext = createContext<ShellState>({ crumbs: [], setCrumbs: () => undefined });

export function ShellProvider({ children }: { children: ReactNode }) {
  const [crumbs, setCrumbs] = useState<Crumb[]>([]);
  return <ShellContext.Provider value={{ crumbs, setCrumbs }}>{children}</ShellContext.Provider>;
}

export function useShellCrumbs(): Crumb[] {
  return useContext(ShellContext).crumbs;
}

/** A page declares where it sits (`Org › Project › Tab`); the shell shows it as a breadcrumb. */
export function usePageCrumbs(crumbs: Crumb[], enabled = true): void {
  const { setCrumbs } = useContext(ShellContext);
  const key = JSON.stringify(crumbs);
  useEffect(() => {
    if (!enabled) return;
    setCrumbs(JSON.parse(key) as Crumb[]);
    return () => setCrumbs([]);
  }, [key, setCrumbs, enabled]);
}
